import { Typography } from '@material-ui/core'
import { useStyles } from './styles'
import { useMemo } from 'react'
import LocationOnIcon from '@material-ui/icons/LocationOn'

interface DistributionCenterProps {
  variant?: 'header' | 'login'
  showIcon?: boolean
}

const DistributionCenter = ({ variant = 'login', showIcon = false }: DistributionCenterProps) => {
  const classes = useStyles()

  const distributionCenter = useMemo(() => {
    const currentUrl = window.location.hostname.toLowerCase()

    if (currentUrl.includes('cd')) {
      return 'CD Piedade'
    }
    if (currentUrl.includes('bh')) {
      return 'CD Belo Horizonte'
    }
    if (currentUrl.includes('stg')) {
      return 'CD Testes'
    }
    if (currentUrl.includes('localhost')) {
      return 'CD Local Host'
    }
    return 'CD Não mapeado'
  }, [])

  if (!distributionCenter) return null

  return (
    <div className={variant === 'login' ? classes.loginContainer : classes.container}>
      {showIcon && <LocationOnIcon className={classes.icon} />}
      <Typography
        variant={variant === 'header' ? 'body1' : 'h6'}
        className={classes.text}
      >
        {distributionCenter}
      </Typography>
    </div>
  )
}

export default DistributionCenter
